import { Action } from "@ngrx/store";
import {
  AccountingBasisData,
  AnalyticsData,
  ExportToExcel,
  ExtrasData,
  PeriodsData,
  RevisionsData,
  SourcesData,
} from "../models/export-to-excel.model";

export const SET_PERIODS_DATA = "SET_PERIODS_DATA";
export const SET_ANALYTICS_DATA = "SET_ANALYTICS_DATA";
export const SET_ACCOUNTING_BASIS_DATA = "SET_ACCOUNTING_BASIS_DATA";
export const SET_SOURCES_DATA = "SET_SOURCES_DATA";
export const SET_REVISIONS_DATA = "SET_REVISIONS_DATA";
export const SET_EXTRAS_DATA = "SET_EXTRAS_DATA";
export const SET_EXPORT_TO_EXCEL_DATA = "SET_EXPORT_TO_EXCEL_DATA";

export class SetSourcesData implements Action {
  readonly type = SET_SOURCES_DATA;
  constructor(public payload: SourcesData) {}
}

export class SetPeriodsData implements Action {
  readonly type = SET_PERIODS_DATA;
  constructor(public payload: PeriodsData) {}
}

export class SetAnalyticsData implements Action {
  readonly type = SET_ANALYTICS_DATA;
  constructor(public payload: AnalyticsData) {}
}

export class SetAccountingBasisData implements Action {
  readonly type = SET_ACCOUNTING_BASIS_DATA;
  constructor(public payload: AccountingBasisData) {}
}

export class SetRevisionsData implements Action {
  readonly type = SET_REVISIONS_DATA;
  constructor(public payload: RevisionsData) {}
}

export class SetExtrasData implements Action {
  readonly type = SET_EXTRAS_DATA;
  constructor(public payload: ExtrasData) {}
}

export class SetExportToExcelData implements Action {
  readonly type = SET_EXPORT_TO_EXCEL_DATA;
  constructor(public payload: ExportToExcel) {}
}

export type Actions =
  | SetAnalyticsData
  | SetPeriodsData
  | SetAccountingBasisData
  | SetSourcesData
  | SetRevisionsData
  | SetExtrasData
  | SetExportToExcelData;
